

























































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetTonguePreview } from "@/request/tongue";
import PicPreview from "@/components/pic-preview.vue";
import { BiduiPreview } from "@/request/tongue";
@Component({
  components: {
    PicPreview,
  },
})
export default class TonguePreview extends Vue {
  private loaded: boolean = false;
  private selectedTongues: any[] = [];
  private createdTime = "";
  private tempUrl: any = "";
  private ifShowPreview: boolean = false;
  private results: any = {
    定性特征参数: {},
    几何特征参数: {},
    舌图分组: {},
  };
  /**
   * @description 获取数据xx
   */
  private fetchResult() {
    this.loaded = false;
    const params: any = {
      tongue_ids: this.selectedTongues.map((tongue) => tongue["tongue_id"]),
    };
    BiduiPreview(this, params).then((data: any) => {
      this.results = data;
      this.loaded = true;
    });
  }
  /**
   * @description 打开图片预览
   */
  private showPreview(src) {
    this.tempUrl = src;
    this.ifShowPreview = true;
  }
  /**
   * @description 跳转定性特征编辑
   */
  private jumpDingxing(item) {
    this.$router.push({
      path: "/main/tongue/biaozhu-detail",
      query: {
        tongue_id: item.tongue_id,
      },
    });
  }
  /**
   * @description 跳转几何特征编辑
   */
  private jumpJihe(item) {
    this.$router.push({
      path: "/main/tongue/biaozhu-detail",
      query: {
        tongue_id: item.tongue_id,
        part: "几何",
      },
    });
  }
  /**
   * @description 跳转舌图分组编辑
   */
  private jumpFenzu(item) {
    this.$router.push({
      path: "/main/tongue/biaozhu-detail",
      query: {
        tongue_id: item.tongue_id,
        part: "分组",
      },
    });
  }
  /**
   * @description 展示数组
   */
  private showArr(item) {
    if (Array.isArray(item)) {
      return item.join(",");
    } else {
      return item;
    }
  }
  /**
   * @description 初始化
   */
  private mounted() {
    const arr = localStorage.getItem("selectedTongues");
    if (arr) {
      this.selectedTongues = JSON.parse(arr);
      console.log(this.selectedTongues);
      this.fetchResult();
    }
    this.createdTime = localStorage.getItem("biduiTime") || "";
  }
}
